import PropTypes from 'prop-types';
import { useState, useRef, useEffect } from 'react';

MenuPopover.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func,
};

export default function MenuPopover({ children, className = '', anchorEl, onClose, ...other }) {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const popoverRef = useRef(null);

  useEffect(() => {
    if (anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.right + window.scrollX,
      });
    }
  }, [anchorEl]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target) && !anchorEl.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [anchorEl, onClose]);

  if (!anchorEl) return null;

  return (
    <div
      ref={popoverRef}
      className={`fixed z-50 w-[200px] p-1 bg-white rounded-lg shadow-lg ${className}`}
      style={{
        top: `${position.top}px`,
        left: `${position.left - 200}px`,
      }}
      {...other}
    >
      <div className="absolute -top-2 right-5 w-3 h-3 bg-white transform rotate-45 border-r border-b border-gray-200" />
      {children}
    </div>
  );
}
